<h2 style="text-align:center">Advice Area</h2>
<router-outlet *ngIf="!loading" name="meeting_4"></router-outlet>

<survey-project-advice *ngIf="auth.isProject() || auth.isAdmin() || auth.isCallManager() || auth.isProjectBoard()"></survey-project-advice>
